<template>
  <avtalat-dialog :idealWidth="500" :idealHeight="300"
    ><div>
      <div>
        <span v-if="showUnchangedDefaultMessageWarning">
          Du har inte ändrat i standardmeddelandet som skickas till kunden. Vill
          du fortsätta ändå?
        </span>
        <span
          v-if="showUnchangedDefaultMessageWarning && showEmailMissingWarning"
          ><br /><br
        /></span>
        <span v-if="showEmailMissingWarning"
          >Personen saknar e-postadress. Om du sparar detta ärende kommer du skicka
        ett säkert meddelande till kunden utan att kunden får en notifiering om
        att det finns ett nytt säkert meddelande.</span
        >
      </div>
      <div class="mt-sm flex justify-evenly">
        <avtalat-button outlined @click="() => emit('cancel')"
          >Avbryt</avtalat-button
        >
        <avtalat-button @click="() => emit('submit')">{{
          submitButtonText
        }}</avtalat-button>
      </div>
    </div></avtalat-dialog
  >
</template>

<script setup lang="ts">
import { computed } from "vue";

type SubmissionWarningDialogProps = {
  showUnchangedDefaultMessageWarning?: boolean;
  showEmailMissingWarning?: boolean;
};

const props = withDefaults(defineProps<SubmissionWarningDialogProps>(), {
  showUnchangedDefaultMessageWarning: false,
  showEmailMissingWarning: true,
});

const emit = defineEmits(["submit", "cancel"]);

const submitButtonText = computed(() =>
  props.showEmailMissingWarning ? "Spara ändå" : "Fortsätt",
);
</script>
